import { FC } from 'react';

import { useMediaQuery } from '~/common/hooks/use-media-query';
import { Typography } from '~/common/components/Typography';
import { Modal } from '~/common/components/Modal';

import { StyContainer, StyContent } from './styles';

interface ICompanyInfoModal {
  open: boolean;
  close: () => void;
}
export const CompanyInfoModal: FC<ICompanyInfoModal> = ({ open, close }) => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <Modal
      title="Informações da empresa"
      isOpen={open}
      onClose={close}
      id="company-info-modal"
      height={isMobile ? '500px' : 'auto'}
      width="500px"
    >
      <StyContainer>
        <StyContent>
          <Typography.Label size="medium">
            Canais de Atendimento:
          </Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            E-mail geral: contact@cryptocontrol.pro
            <br />
            Telefone: (11) 96742-8387
          </Typography.Label>
        </StyContent>

        <StyContent>
          <Typography.Label size="medium">
            Horário de Atendimento:
          </Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            E-mail geral: Segunda a sexta-feira: 9h às 18h Sábados, domingos e
            feriados: atendimento por e-mail Horário de Brasília (GMT-3)
          </Typography.Label>
        </StyContent>

        <StyContent>
          <Typography.Label size="medium">Redes Sociais:</Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            Instagram: @cryptocontrol.pro
            <br />
            YouTube: @CryptoControlPRO
          </Typography.Label>
        </StyContent>
      </StyContainer>
    </Modal>
  );
};
